import scribdAuthorize from '../../scribd/scribd_oauth.js';
import { player } from "../../new_player/selectors";

const LOCAL_STORAGE_KEY = 'contentAccountGateData';

export const getAllowedContentCountWithoutAccount = () => {
  const allowedContentCountWithoutAccount = 5;
  /**
   * window.ab_tests can be used to return different values depending upon test value
   */
  return allowedContentCountWithoutAccount;
};

export const getContentAccountGatePeriod = () => {
  // time period is in days
  const contentAccountGatePeriod = 30;
  /**
   * window.ab_tests can be used to return different values depending upon test value
   */
  return contentAccountGatePeriod;
};

export const getContentCountToStartRenderingBannerNotificatons = () => {
  const contentCountToStartRenderingBannerNotificatons = 2;
  /**
   * window.ab_tests can be used to return different values depending upon test value
   */
  return contentCountToStartRenderingBannerNotificatons;
};

export const getShouldShowBannerNotificationsUX = (allowedContentCount, contentAccountGateDataLength, contentCountWithoutBannerNotifications) => {
  return {
    shouldShowBanner: ((allowedContentCount - contentAccountGateDataLength) <= contentCountWithoutBannerNotifications),
    remainingDocCount: allowedContentCount - contentAccountGateDataLength
  };
};

export const getShouldShowReaderBlur = (allowedContentCount, contentAccountGateDataLength) => {
  return allowedContentCount <= contentAccountGateDataLength;
};

export const getDateIsoStrFromPast = (dayCount) => {
  // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
  const currentDateInMilliSeconds = Date.now();
  return new Date(currentDateInMilliSeconds - 1000 * 60 * 60 * 24 * dayCount).toISOString();
}

export const purgeData = (contentAccountGateData, contentAccountGatePeriod) => {
  const contentAccountGatePeriodStartTime = getDateIsoStrFromPast(contentAccountGatePeriod);
  return contentAccountGateData.filter((item) => {
    // check if the doc was accessed less than 30 days ago
    return (item.accessedDateTime > contentAccountGatePeriodStartTime);
  });
};

export const isRevisit = (contentAccountGateData, slideshowId) => {
  const foundIndex = contentAccountGateData.findIndex((item) => item.id === slideshowId);
  return foundIndex > -1;
};

export const getIsValidIsoDate = (dateStr) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(dateStr)) {
    return false;
  } else {
    return new Date(dateStr).toISOString() === dateStr;
  }
};

const hasValidId = (id) => !!id && typeof id === 'string';
const hasValidDate = (dateTime) => !!dateTime && getIsValidIsoDate(dateTime);

/**
 * Function to protect against users editing data in local storage
 * @param [{ id: string, accessedDateTime: string, viewRestrictionAbTestValue: string }] contentAccountGateData 
 * @returns [{ id: string, accessedDateTime: string, viewRestrictionAbTestValue: string }]
 */
export const verifyAndFilterDataFromLocalStorage = (contentAccountGateData) => {
  if (Array.isArray(contentAccountGateData)) {
    return contentAccountGateData.filter((item) => {
      if (hasValidId(item.id) && hasValidDate(item.accessedDateTime)) {
        return true;
      } else {
        return false;
      }
    });
  } else {
    return [];
  }
};

export const getInfoFromLocalStorage = (viewRestrictionAbTestValue) => {
  return JSON.parse(window.localStorage.getItem(`${LOCAL_STORAGE_KEY}_${viewRestrictionAbTestValue}`));
};

export const setInfoToLocalStorage = (data, viewRestrictionAbTestValue) => {
  window.localStorage.setItem(`${LOCAL_STORAGE_KEY}_${viewRestrictionAbTestValue}`, JSON.stringify(data));
};

const logEvent = (eventName) => {
  const slideshow = window.slideshare_object.slideshow;
  const options = {
    slideshow_id: slideshow.id,
    slideshow_created_at: slideshow.created_at,
    slideshow_category: window.slideshare_object.gam_cat_name,
    slideshow_language: slideshow.language,
    slideshow_format: slideshow.type,
  };

  if (typeof amplitude !== 'undefined') {
    amplitude.getInstance().logEvent(eventName, options);
  }
}

export const logViewRestrictionEvent = (contentViewedCount) => {
  const maxContentCount = getAllowedContentCountWithoutAccount();
  const isShowingBannerForFirstTime =
    contentViewedCount ===
    maxContentCount - getContentCountToStartRenderingBannerNotificatons(); 
  const isShowingRestrictionForFirstTime =
    contentViewedCount === maxContentCount;

  if (isShowingBannerForFirstTime) {
    logEvent('view_restriction_banner_shown');
  } else if (isShowingRestrictionForFirstTime) {
    logEvent('view_restriction_threshold_hit');

  }
};

// function to clear contentAccountGateData from local storage when ab test value assignments change
export const clearContentAccountGateDataFromLocalStorage = (currentViewRestrictionAbTestValue) => {
  const possibleViewRestrictionAbTestValues = ['control', 'show_view_restirction'];
  possibleViewRestrictionAbTestValues.map((abTestVal) => {
    if (abTestVal !== currentViewRestrictionAbTestValue) {
      const data = verifyAndFilterDataFromLocalStorage(getInfoFromLocalStorage(abTestVal));
      if (data.length > 0) {
        // remove the data from local storage
        window.localStorage.removeItem(`${LOCAL_STORAGE_KEY}_${abTestVal}`);
      }
    }
  });
};

export const localStorageEnabled = () => {
  try {
    window.localStorage.setItem('slideshare_test', 'test');
    window.localStorage.removeItem('slideshare_test');
    return true;
  } catch (e) {
    return false;
  }
};

const addDocumentToContentData = (
  data,
  slideshowId
) => {
  data.push({
    id: slideshowId,
    accessedDateTime: new Date().toISOString(),
  });
  logViewRestrictionEvent(data.length);
  return data;
};

export const getFilteredAccountGateData = () => {
  const viewRestrictionAbTestValue = "control";
  const contentAccountGateData = verifyAndFilterDataFromLocalStorage(
    getInfoFromLocalStorage(viewRestrictionAbTestValue)
  );
  return purgeData(
    contentAccountGateData,
    getContentAccountGatePeriod()
  );
}

export const userDocumentTracking = ({ slideshowId, allowedContentCount, viewRestrictionAbTestValue }) => {
  const contentAccountGateData = verifyAndFilterDataFromLocalStorage(getInfoFromLocalStorage(viewRestrictionAbTestValue));
  
  if (contentAccountGateData.length > 0) {
    const purgedContentAccountGateData = purgeData(
      contentAccountGateData,
      getContentAccountGatePeriod()
    );
    const isRevisited = isRevisit(purgedContentAccountGateData, slideshowId);
    if (!isRevisited && purgedContentAccountGateData.length < allowedContentCount) {
      return addDocumentToContentData(purgedContentAccountGateData, slideshowId);
    }
    return purgedContentAccountGateData;
  } else {
    // contentAccountGateData does not exist in localStorage
    return [{
      id: slideshowId,
      accessedDateTime: new Date().toISOString()
    }];
  }
};

const getBannerNotificationText = (remainingDocCount, slideshare_object) => {
  const utils = slideshare_object.utils;
  if (remainingDocCount <= 0) {
    return utils.i18n('slideshow.foundation_slideview.limit_content_without_account.notification_banner_ran_out_text');
  } else if (remainingDocCount === 1) {
    return utils.i18n('slideshow.foundation_slideview.limit_content_without_account.notification_banner_last_document_text');
  } else {
    return utils.i18n('slideshow.foundation_slideview.limit_content_without_accoun.notification_banner_text', { count: remainingDocCount });
  }
};

const handleScribdAuthorize = () => {
  const slideshare_object = window.slideshare_object;
  const slideshow = slideshare_object && slideshare_object.slideshow;
  scribdAuthorize({ from_source: slideshow.ss_url, slideshow_id: slideshow.id });
};

export const handleBannerNotification = (shouldShowBanner, remainingDocCount, slideshare_object) => {
  if (shouldShowBanner) {
    const $banner = $('.limit-notification');
    const $notificationWarningtextElem =  $banner.find('#notification-warning-text');
    $notificationWarningtextElem.empty();
    $notificationWarningtextElem.append(getBannerNotificationText(remainingDocCount, slideshare_object));
    $banner.find('#notification-warning-link').on('click', handleScribdAuthorize);
    $banner
      .css('opacity', 0)
      .slideDown(400)
      .animate(
        { opacity: 1 },
        { queue: false, duration: 400 }
      );
    return;
  }
};

export const showLimitOverlay = () => {
  const $limitOverlay = $('.limit-overlay');
  $limitOverlay.find('#sign-up-with-scribd').on('click', handleScribdAuthorize);
  $limitOverlay.css('display', '');
  player.addClass('guest-limit');
};

export const hideLimitOverlay = () => {
  const $limitOverlay = $('.limit-overlay');
  $limitOverlay.css('display', 'none');
  player.removeClass('guest-limit');
}
